export default __webpack_public_path__ + "static/media/BIMWin.afaa2921.png";